<h2 class="item-page-title-field">
  <div *ngIf="item.firstMetadataValue('dspace.entity.type') as type">
    {{ type.toLowerCase() + '.page.titleprefix' | translate }}
  </div>
  <div class="d-flex justify-content-between">
    <ds-metadata-values [mdValues]="item?.allMetadata(fields)"></ds-metadata-values>
  </div>
</h2>
